import Image from 'next/image';
import { Inter } from 'next/font/google';
import {
  AboutUs,
  BusinessAreas,
  Certification,
  FAQ,
  Gallary,
  NumberCounting,
  Partner,
  Products,
  ProjectArea,
  Reason,
  Slider,
} from '@/components/Homepage';
import { ContactCTA, SEOHead } from '@/components/Shared';
import {
  PRIMARY_ADDRESS,
  SECONDARY_ADDRESSES,
  getCompanyAddressesJsonLd,
} from '@/constants/companyInfo';

const inter = Inter({ subsets: ['latin'] });

const siteUrl = 'https://www.truongthofood.vn';

const [secondaryAddress] = SECONDARY_ADDRESSES;

const homeDescriptionBase =
  'Trường Thọ Food chuyên cung cấp trứng gà tươi và trứng bóc vỏ sẵn chất lượng cao. Sản phẩm đảm bảo vệ sinh an toàn thực phẩm, giá cả cạnh tranh. Hotline: 083 419 4986.';

const homeDescription =
  `${homeDescriptionBase} Địa chỉ: ${PRIMARY_ADDRESS.fullAddress}` +
  (secondaryAddress
    ? `. Chi nhánh: ${secondaryAddress.fullAddress}`
    : '');

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Trường Thọ Food',
  url: siteUrl,
  logo: `${siteUrl}/logo-hori.png`,
  description:
    'Công ty chuyên cung cấp trứng gà tươi và trứng bóc vỏ sẵn chất lượng cao, đảm bảo vệ sinh an toàn thực phẩm',
  address: getCompanyAddressesJsonLd(),
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+84-83-419-4986',
    contactType: 'customer service',
    email: 'truongthofood68@gmail.com',
    areaServed: 'VN',
    availableLanguage: ['Vietnamese'],
  },
  sameAs: [],
  foundingDate: '2020',
  numberOfEmployees: {
    '@type': 'QuantitativeValue',
    value: '10-50',
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="Trường Thọ Food - Trứng Gà Tươi & Trứng Bóc Vỏ Sẵn Chất Lượng Cao"
        description={homeDescription}
        keywords="trứng gà, trứng gà tươi, trứng bóc vỏ sẵn, trứng chế biến sẵn, nông sản, thực phẩm sạch, công ty Trường Thọ, Trường Thọ Food, trứng gà Dĩ An, trứng gà Hồ Chí Minh, trứng gà tươi số 1, trứng gà chất lượng cao"
        image={`${siteUrl}/banner.png`}
        url={siteUrl}
        structuredData={organizationSchema}
      />
      <main>
        <Slider />
        <AboutUs />
        <BusinessAreas />
        <Certification />
        <Reason />
        <Products />
        {/* <ProjectArea />  */}
        <NumberCounting />
        <FAQ />
        <ContactCTA />
        <Gallary />
        <Partner />
      </main>
    </>
  );
}
